import {
  ChatActionType,
  TemplateButtons,
  isWeb,
  MessageEnvelope,
} from '@zonofi/common';
import { i18nService } from '@zonofi/i18n';
import { ButtonPayload, TemplateButtonKeys } from '../types';
import { onButtonPress } from '../functions/template-button-handlers';
import i18next from 'i18next';

export const TemplateButtonsMap = (
  isDistributor: boolean,
  props: MessageEnvelope | ButtonPayload,
  isLoading?: boolean,
  buttonText?: string
): Record<TemplateButtonKeys, Omit<TemplateButtons, 'type'>> => ({
  view_order: {
    text: buttonText || i18nService.t('chats:VIEW_ORDER'),
    onPress: () => {
      if (isWeb()) {
        onButtonPress('view_order', props);
      } else {
        onButtonPress(ChatActionType.VIEW_ORDER, props);
      }
    },
    condition: isWeb() || Object.values(props as ButtonPayload).every((x) => x),
    permissions: [],
  },
  upload_invoice: {
    text: i18nService.t('chats:UPLOAD_INVOICE'),
    onPress: () => onButtonPress(ChatActionType.CREATE_INVOICE, props),
    condition: !isDistributor,
    permissions: [],
  },
  view_campaign: {
    text: i18nService.t('chats:VIEW_CAMPAIGN'),
    onPress: () => onButtonPress(ChatActionType.VIEW_CAMPAIGN, props),
    condition: !isDistributor,
    permissions: [],
  },
  create_order: {
    text: buttonText || i18nService.t('chats:CREATE_ORDER'),
    onPress: () => onButtonPress(ChatActionType.CREATE_ORDER, props),
    condition: !isDistributor,
    permissions: [],
  },
  view_invoice: {
    text: i18nService.t('chats:VIEW_INVOICE'),
    onPress: () => onButtonPress(ChatActionType.VIEW_INVOICE, props),
    condition: true,
    permissions: [],
  },
  download_invoice: {
    text: i18nService.t('chats:DOWNLOAD_INVOICE'),
    onPress: () => onButtonPress('download_invoice', props),
    condition: true,
    isLoading: isLoading,
    permissions: [],
  },
  accept_payment: {
    text: i18nService.t('chats:REVIEW_CONFIRM_PAYMENT'),
    onPress: () =>
      onButtonPress(ChatActionType.REVIEW_AND_ACCEPT_PAYMENT, props),
    condition: !isDistributor,
    disabled: Object.keys((props as MessageEnvelope).actions || {}).some((x) =>
      ['accpetPayment', 'rejectPayment'].includes(x)
    ),
    permissions: ['payments_write'],
  },
  reject_payment: {
    text: i18nService.t('chats:PAYMENT_NOT_RECEIVED'),
    onPress: () => onButtonPress('reject_payment', props),
    color: '#EA0500',
    condition: !isDistributor,
    disabled: Object.keys((props as MessageEnvelope).actions || {}).some((x) =>
      ['confirmPayment', 'rejectPayment'].includes(x)
    ),
    permissions: ['payments_write'],
  },
  review_invoice: {
    text: i18nService.t('chats:REVIEW_INVOICES'),
    onPress: () => onButtonPress(ChatActionType.REVIEW_PAYMENT_INVOICE, props),
    condition: true,
    permissions: [],
  },
  view_dispatch: {
    text: i18nService.t('chats:VIEW_DISPATCH'),
    onPress: () => onButtonPress(ChatActionType.VIEW_DISPATCH_NOTE, props),
    condition: true,
    permissions: [],
  },
  view_survey_response: {
    text: 'View Response',
    onPress: () => onButtonPress(ChatActionType.SURVAY_FORM_ANSWERS, props),
    condition: isWeb() && Object.values(props as ButtonPayload).every((x) => x),
    permissions: [],
  },
  view_contact: {
    text: i18next.t('chats:VIEW_ALL'),
    onPress: () => onButtonPress('view_contact', props),
    condition: !isWeb(),
    permissions: [],
  },
});

export const updateTemplateTypeButtonsMap = (
  map: Record<string, string[]>,
  type: string,
  value: string[]
): Record<string, string[]> => {
  map[type] = value;
  return map;
};
